//#region Styles
import { 
    Column, 
    ParagraphSection, 
    SubtitleSection } from "components/styles";
//#endregion

const NoRecordsMessage = () => {
    return (
        <Column marginTop="10px" gap="10px">
            <SubtitleSection>Registros</SubtitleSection>
            <ParagraphSection className="secondary">Aun no hay registros disponibles.</ParagraphSection>
        </Column>
    );
}

export default NoRecordsMessage;